import { Outlet, useNavigate } from "react-router-dom";
import './../../assets/styles/fintech.css'
import { useAppDispatch } from "../../hooks/hooks";
import { settings } from "../../redux/settings/actions";
import { useSelector } from "react-redux";
import { selectCurrent } from "../../redux/settings/selectors";
import Settings from "../../components/nexus/Settings";
import Header from "../../components/nexus/Header";
import Sidebar from "../../components/nexus/Sidebar";
import Footer from "../../components/nexus/Footer";
import { useEffect, useState } from "react";

const NexusLayout = () => {
	let navigate = useNavigate()
	const dispatch = useAppDispatch()
	
	const [color, setColor] = useState('universal')
	
	const handleSettigns = () => {
		dispatch(settings.set({ visible: !visible }))
	}

	const result = useSelector(selectCurrent)
	const { header, footer, visible, sidebar,theme } = result
	useEffect(() => {
		setColor(theme)
		if (theme == 'darkmode') {
			dispatch(settings.set({ primary: '#f5e93cac' }))
			dispatch(settings.set({ secondary: '#ffffff' }))
		
		}
		else if (theme == 'lightmode') {
			dispatch(settings.set({ primary: '#ffffffa2' }))
			dispatch(settings.set({ secondary: '#000000a2' }))
		}
		else if (theme == 'universal') {
			dispatch(settings.set({ primary: '#233C64' }))
			dispatch(settings.set({ secondary: '#ffffff' }))
		}
		else if (theme == 'luxury') {
			dispatch(settings.set({ primary: '#bd238c' }))
			dispatch(settings.set({ secondary: '#ffffff'}))
		
		}
		else if (theme == 'harmony') {
			dispatch(settings.set({ primary: '#000000a2'}))
			dispatch(settings.set({ secondary: '#000000a2'}))
		}
		else if (theme == 'warmth') {
			dispatch(settings.set({ primary: '#000000a2'}))
			
		}
		// const data = document.getElementById("layer") as HTMLInputElement;
		// data.setAttribute("fill", "#603812")
		// data.setAttribute("stroke", "#603812")
	}, [theme]);
	return (
		<>
	
			<div className="leading-normal tracking-normal" id="main-body">
				<div className="flex flex-wrap sm:hide">
					{visible ? <Settings /> : <></>}
					<div className="w-full bg-gray-100 sm:pl-0  lg:pl-64 min-h-screen" id="main-content">
						{sidebar ? <Sidebar /> : <></>}
						<div className={sidebar ? "bg-gray-200 dark:bg-slate-300" : "bg-gray-200 dark:bg-slate-300 -ml-64"}>
							<Header />
							<Outlet />
						</div>
						{footer ? <Footer /> : ""}
					</div>
				</div>
			</div>

			</>
	)
}
export default NexusLayout;